import React from 'react';
import { useNavigate } from 'react-router-dom';
import { apiUrl, getCsrfToken } from '../api';
import Logo from './Logo';

const DASHBOARD_VIEWS = new Set(['dashboard', 'employees', 'form']);

const WorkspaceNav = ({ activeView, onSelectView }) => {
    const navigate = useNavigate();

    const selectView = (view) => {
        if (view === 'harassment') {
            navigate('/harassment-training');
            return;
        }

        if (onSelectView && DASHBOARD_VIEWS.has(view)) {
            onSelectView(view);
            return;
        }

        navigate('/dashboard', { state: { workspaceView: view } });
    };

    const handleLogout = async () => {
        try {
            const csrfToken = await getCsrfToken();
            const response = await fetch(apiUrl('/api/logout'), {
                method: 'POST',
                credentials: 'include',
                headers: { 'X-CSRF-Token': csrfToken }
            });
            if (!response.ok) throw new Error('Unable to log out.');
            window.location.href = '/login';
        } catch (error) {
            window.alert(error.message || 'Unable to log out.');
        }
    };

    const navButton = (view, label) => (
        <button
            type="button"
            className={`nav-btn ${activeView === view ? 'active' : ''}`}
            onClick={() => selectView(view)}
            aria-current={activeView === view ? 'page' : undefined}
        >
            {label}
        </button>
    );

    return (
        <nav className="main-nav" aria-label="Workspace navigation">
            <Logo size="small" />
            <div className="main-nav-links">
                {navButton('dashboard', 'Overview')}
                {navButton('employees', 'Employees')}
                {navButton('harassment', 'Harassment evidence')}
                {navButton('form', 'Log incident')}
            </div>
            <button
                type="button"
                className="nav-btn main-nav-logout"
                onClick={handleLogout}
            >
                Log out
            </button>
        </nav>
    );
};

export default WorkspaceNav;
